'use client'

import React from 'react'
import type { TripleseatFormBlock as TripleseatFormBlockProps } from '@/payload-types'
import { useTripleseatForm } from './hooks/useTripleseatForm'
import styles from './styles.module.css'
import './datepicker.css'
import { cn } from '@/utilities/ui'
import { getBlockPadding } from '@/utilities/getBlockPadding'

const TripleseatFormRenderer: React.FC<{
  leadFormId: string
  publicKey: string
}> = ({ leadFormId, publicKey }) => {
  const { containerRef, isLoading, error } = useTripleseatForm({ leadFormId, publicKey })

  if (error) {
    return <div className={styles.errorContainer}>{error}</div>
  }

  return (
    <>
      {isLoading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner}></div>
          Loading form...
        </div>
      )}
      <div ref={containerRef} />
    </>
  )
}

export const TripleseatFormBlock: React.FC<
  TripleseatFormBlockProps & { disableInnerContainer?: boolean }
> = ({ leadFormId, publicKey, paddingTop, paddingBottom, disableInnerContainer }) => {
  const paddingClasses = getBlockPadding({
    paddingTop: paddingTop ?? true,
    paddingBottom: paddingBottom ?? true,
  })

  if (!leadFormId || !publicKey) {
    return (
      <div className={cn(paddingClasses, 'flex justify-center', { container: !disableInnerContainer })}>
        <div className="p-4 text-center text-gray-500">
          Form temporarily unavailable. Please try again later.
        </div>
      </div>
    )
  }

  return (
    <div className={cn(paddingClasses, 'flex justify-center', { container: !disableInnerContainer })}>
      <div className={cn('w-full', styles.tripleseatFormContainer)}>
        <TripleseatFormRenderer leadFormId={leadFormId} publicKey={publicKey} />
      </div>
    </div>
  )
}
